import {useEffect} from 'react'
import {useSearchParams, useParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import {ROLE_EXTERNAL_ADMIN} from 'shared/constant/lookup/role'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetEvenParticipantTemplateList = (reloadTrigger) => {
	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [searchParams] = useSearchParams()
	const [userRole] = useRoleCookie()

	const page = searchParams.get('page') || 1
	const sortBy = searchParams.get('sortBy')
	const sortDirection = searchParams.get('sortDirection')
	const {idx} = useParams()

	const [, setAlert] = useAlertModalAtom()

	useEffect(() => {
		const rolePath = getApiRolePath(userRole)
		let path = `/${rolePath}/seed-ticket/${idx}/batches?page=${page}`

		if (sortBy) path += `&sortBy=${sortBy}`
		if (sortDirection) path += `&sortDirection=${sortDirection}`

		fetchRequest('GET', path)
	}, [page, sortBy, sortDirection, idx, reloadTrigger])

	useEffect(() => {
		if (fetchResult?.statusCode) {
			switch (fetchResult?.statusCode) {
				case 200:
					break
				case 400:
					if (fetchResult?.data?.error_code === 'page')
						setAlert('페이지 번호를 확인해 주세요.')
					else if (fetchResult?.data?.error_code === 'search')
						setAlert('검색어를 확인해 주세요.')
					else setAlert('입력한 값의 형식이 잘못되었습니다.')
					break
				default:
					break
			}
		}
	}, [fetchResult])

	return [fetchResult, isLoading]
}

export default useGetEvenParticipantTemplateList
